import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
// core components
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import GridItem from "../../../views/GridItem";
import GridContainer from "../../../views/GridContainer";
import Table from "../../../views/Table";
import Card from "../../../views/Card";
import CardHeader from "../../../views/CardHeader";
import CardBody from "../../../views/CardBody";
import { withSnackbar } from 'notistack';
import { styles } from './styles';
import ConfirmDialog from './ConfirmDialog'
import Edit from './Edit'
import Apis from '../../../../utils/Apis'
import NewType from "./NewType";
import Workbook from 'react-excel-workbook'

class TypeManage extends Component {
    state = {
        types_count: 0,
        pageNumber: 1,
        types: [],
        temp_page: [],
        export_types: [],
        isLoading: false,
        open_register: false,
        open_edit: false,

        id: '',
        name: '',
        instruction: ''
    }

    componentWillMount() {
        const { pageNumber } = this.state;
        this.gettypes(pageNumber);
    }
    gettypes = async (pageNumber) => {
        this.setState({ isLoading: true });
        try {
            let response = await Apis.getTypes();
            let types = response.data;
            const { classes } = this.props;
            let temp = [];
            let temp_types = [];
            var index = 0;
            for (let i = 0; i < types.length; i++) {
                let type_id = types[i]['_id'];
                let name = types[i]['name'];
                let instruction = types[i]['instruction'];
                let active = types[i]['active'];
                temp = [...temp,
                [

                    <Typography noWrap className={classes.typographyContent}>{i + 1}</Typography>,
                    <Typography noWrap className={classes.typographyContent}>{name}</Typography>,
                    <p noWrap className={classes.typographyContent}>{instruction}</p>,
                    this.operationViewActive(type_id, active),
                    this.operationViewEdit(type_id, name, instruction)

                ]
                ];
		
                temp_types = [
                    ...temp_types,
                    { No: i + 1, Name: name, Instruction: instruction, Active: active }
                ];
            }

            const { pageNumber } = this.state;
            let temp_page = [];
            temp_page = temp;

            this.setState({ pageNumber: pageNumber, isLoading: false, types_count: types.length, types: temp, temp_page: temp_page, export_types: temp_types })


        }
        catch (error) {
            let messageProperty = Object.getOwnPropertyDescriptor(error, 'message');
            this.setState({ isLoading: false });
            this.props.enqueueSnackbar(messageProperty.value, {
                variant: 'error',
            });
        }
    }
    operationViewActive = (type_id, active) => {
        return (
            <Grid container>
                {this.viewCheckActive(type_id, active)}
            </Grid>
        )
    }
    viewCheckActive = (type_id, active) => {
        const { classes } = this.props;
        return (
            <Checkbox
                checked={active}
                onClick={this.onActionActive(type_id)}
                value="type_id"
                color="primary"
            />
        );
    }
    onActionActive = type_id => event => {
        Apis.updateTypeStatus(type_id, event.target.checked)
            .then(res => {
                const { pageNumber } = this.state;
                this.gettypes(pageNumber);
            })
            .catch(err => {
            })
    }
    operationViewEdit = (type_id, name, instruction) => {
        return (
            <Grid container>
                {this.viewButtonEdit(type_id, name, instruction)}
            </Grid>
        )
    }
    viewButtonEdit = (type_id, name, instruction) => {
        const { classes } = this.props;
        return (
            <Button color="secondary" className={classes.viewButton} disableRipple disableFocusRipple onClick={() => this.onActionViewEdit(type_id, name, instruction)} >
                {'Edit'}
            </Button>
        );
    }
    onActionViewEdit = (type_id, name, instruction) => {
        this.setState({ open_edit: true, id: type_id, name: name, instruction: instruction });
    }
    // action for pagination
    handleChangePage = (event, page) => {
        const { pageNumber, types } = this.state;
        this.setState({
            pageNumber: page + 1,
        });
    }
    createNew = () => {
        const { requesting } = this.props;
        if (requesting) {
            return;
        }
        this.setState({ open_register: true });
    }
    onCloseRegister = () => {
        this.setState({ open_register: false, open_edit: false });
    }
    onDoneRegister = () => {
        this.setState({ open_register: false, open_edit: false });
        const { pageNumber } = this.state;
        this.gettypes(pageNumber);
    }
    
    onAlertMessage = (type, message) => {
        this.props.enqueueSnackbar(message, {
            variant: type,
        });
    }
    render() {
        const { classes } = this.props;
        const { types_count, pageNumber, temp_page, isLoading, export_types } = this.state;
        return (
            <div container>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="primary">
                                <h4 className={classes.cardTitleWhite}>Types</h4>
                            </CardHeader>
                            <CardBody>
                                <Table
                                    tableHeaderColor="black"
                                    tableHead={[<b>No</b>, <b>Name</b>, <b>Health & Safety Instruction</b>, <b>Active</b>, <b>Action</b>]}
                                    tableData={temp_page}
                                    handleChangePage={this.handleChangePage}
                                    containerHeight={620}
                                    totalCount={temp_page.length}
                                    rowsPerPage={10}
                                    page={pageNumber}
                                    isLoading={isLoading}
                                />
                                <Grid container xs={12} sm={12} md={12}>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={9}>
                                    </Grid>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={1}>
                                        <Workbook filename="types.xlsx" element={<Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple>Export</Button>}>
                                            <Workbook.Sheet data={export_types} name="Sheet A">
                                                <Workbook.Column label="No" value="No" />
                                                <Workbook.Column label="Name" value="Name" />
                                                <Workbook.Column label="Instruction" value="Instruction" />
                                                <Workbook.Column label="Active" value="Active" />
                                            </Workbook.Sheet>
                                        </Workbook>
                                    </Grid>
                                    <Grid container direction="column" justify="center" alignItems="stretch" xs={12} sm={12} md={2}>
                                        <Button variant="contained" color="primary" className={classes.btnUpdate} disableRipple onClick={this.createNew}>
                                            New Type
                                    </Button>
                                    </Grid>
                                </Grid>
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <NewType
                    onClose={this.onCloseRegister}
                    onAlertMessage={this.onAlertMessage}
                    open={this.state.open_register}
                    onDoneRegister={this.onDoneRegister} />
                {this.state.open_edit && <Edit
                    onClose={this.onCloseRegister}
                    open={this.state.open_edit}
                    id={this.state.id}
                    name={this.state.name}
                    instruction={this.state.instruction}
                    onDoneEdit={this.onDoneRegister}
                    onAlertMessage={this.onAlertMessage} />}
            </div>
        );
    }
}

TypeManage.propTypes = {
    classes: PropTypes.object.isRequired
};

let mapStateToProps = (state) => {
    return {
        email: state.auth.email,
        requesting: state.auth.requesting,
    };
}
export default withStyles(styles)(connect(mapStateToProps, null)(withSnackbar(TypeManage)));
